<template>
    <div :class="[prefixCls]">
        <div
            id="stream_upload_file_btn"
            :class="classes"
            @drop="dragOver = false"
            @dragover.prevent="dragOver = true"
            @dragleave.prevent="dragOver = false"
        >
            <slot></slot>
        </div>
        <slot name="tip"></slot>
        <p style="color: red;margin-top: 5px">{{ $t('Components.upload.upload.prompt.videoFormat') }}mp4、flv、rm、rmvb、wmv、avi、3gp、mkv、mov、asf、mpg、jpg、jpeg、png</p>
        <p style="color: red;margin-top: 5px">{{ $t('Components.upload.upload.prompt.resolution') }}480×360、640*480、720*405、1280*720</p>
        <p style="color: red">{{ $t('Components.upload.upload.prompt.audioFormat') }}mp3、aac、m4a、wav、wma</p>
        <p style="color: red">{{ $t('Components.upload.upload.prompt.imageFormat') }}jpg、jpeg、png、gif</p>
        <p style="color: red">{{ $t('Components.upload.upload.prompt.audioFileSize', {size:audioMaxSizeText}) }}</p>
        <p style="color: red">{{ $t('Components.upload.upload.prompt.imgFileSize', {size:imageMaxSizeText}) }}</p>
        <p style="color: red">{{ $t('Components.upload.upload.prompt.videoFileSize', {size:videoMaxSizeText}) }}</p>
        <div>
            <div style="margin-top: 10px" v-if="uploadType == 1 && hasPermission('uploadVRMatterial')">
                <Checkbox v-model="vrFlag"
                    :false-value="Const.Material.VRFlag.Common"
                    :true-value="Const.Material.VRFlag.VR">{{ $t('Components.upload.upload.vrFlag.checkbox') }}</Checkbox>
                <span style="color: red">{{ $t('Components.upload.upload.vrFlag.prompt') }}</span>
            </div>
            <div v-show="uploadType == 1" style="margin-top: 10px">
                <Checkbox v-model="image_to_video">{{ $t('Components.upload.upload.imageToVideo.checkbox') }}</Checkbox>
                <span style="color: red">{{ $t('Components.upload.upload.imageToVideo.prompt') }}</span>
            </div>
        </div>
        <div style="clear:both"></div>
        <upload-list
            :files="fileList"
            @on-file-remove="handleRemove"
            @on-file-preview="handlePreview"
        ></upload-list>
        <Button
            v-show="fileList.length"
            type="default"
            @click="clearUploadedList"
            size="small"
        >{{ $t('Components.upload.button.cleanUploadList') }}</Button>
    </div>
</template>
<script>
import UploadList from "./upload-list.vue";
// import ajax from './ajax';
import streamUpload from "./stream-v1-upload";
import {Const} from "@/model/ApiModel"
import helper from '@/assets/helper'
import config from '@/config'
import Filetype from "file-type";
import api from "@/api/Api";

const prefixCls = "ivu-upload";

window.Filetype = Filetype;

export default {
    name: "Upload",
    components: { UploadList },
    props: {
        uploadServer: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            default: "file"
        },
        maxSize: {
            type: Number
        },
        categoryId: {
            type: String
        },
        userId: {
            type: String,
            default: ""
        },
        uploadType: {
            type: Number,
            default: 0
        },
        resize: {
            type: Number,
            default: 0
        }
    },
    mixins: [
            {
                methods: helper
            }
    ],
    watch: {
        uploadServer() {
            this._ins.config.tokenURL = this.uploadServer.uploadServerUrl + "/tk";
            this._ins.config.uploadURL = this.uploadServer.uploadServerUrl + "/newFileStreamUpload?type=0";
        },
        fileList(val) {
            this.$store.commit("uploader/setUploading", val);
        },
        uploadType() {
            this._ins.destroy();
            this.insInit();
        },
        image_to_video() {
            this._ins.destroy();
            this.insInit();
        },
        maxSize() {
            if(this.maxSize) {
                this._ins.config.maxSize = this.maxSize;
            }
        }
    },
    data() {
        return {
            Const,
            prefixCls: prefixCls,
            dragOver: false,
            image_to_video: false,
            vrFlag: Const.Material.VRFlag.Common,
            fileList: [],
            tempIndex: 1,
            type: 0
        };
    },
    computed: {
        uploadVideoLimit() {
            return this.$store.getters['uploader/videoMaxSize'](this.$store.state.config.uploadVideoLimit);
        },
        uploadAudioLimit() {
            return this.$store.getters['uploader/audioMaxSize'](this.$store.state.config.uploadAudioLimit);
        },
        uploadImageLimit() {
            return this.$store.getters['uploader/imageMaxSize'](this.$store.state.config.uploadImageLimit);
        },
        videoMaxSizeText() {
            return this.sizeText(this.uploadVideoLimit);
        },
        audioMaxSizeText() {
            return this.sizeText(this.uploadAudioLimit);
        },
        imageMaxSizeText() {
            return this.sizeText(this.uploadImageLimit);
        },
        classes() {
            return [
                `${prefixCls}`,
                {
                    [`${prefixCls}-select`]: true,
                    [`${prefixCls}-drag`]: true,
                    [`${prefixCls}-dragOver`]: this.dragOver
                }
            ];
        },
        extFilters(){
            switch (this.uploadType){
                //视频
                case 1: {
                    if (this.image_to_video) return [".jpg", ".JPG", ".jpeg", ".png"];
                    else return [".mp4", ".flv", ".rm", ".rmvb", ".wmv", ".avi", ".3gp", ".mkv", ".mov", ".asf", ".mpg", ".m4v"];
                }
                //音频
                case 2: return [".mp3", ".aac", ".wma", ".mp2", ".m4a", ".wav"];
                //图片
                case 3: return [".jpg", ".jpeg", ".png", ".gif"];

                default: return [".mp4", ".flv", ".rm", ".rmvb", ".wmv", ".avi", ".3gp", ".mkv", ".mov", ".asf", ".mpg", ".m4v",
                    ".mp3", ".aac", ".wma", ".mp2", ".m4a",
                    ".jpg", ".JPG", ".jpeg", ".png", ".gif"]
            }
        }
    },
    methods: {
        insInit(){
            let THIS = this;
            let errorMsg = null;
            let uploadOptions = {
                // tokenURL: config.cmsServer+"upload/tk.action",
                // uploadURL: config.cmsServer+"upload/newFileStreamUpload.action?type="+this.type,
                tokenURL: this.uploadServer.uploadServerUrl + "/tk",
                uploadURL: this.uploadServer.uploadServerUrl + "/newFileStreamUpload?type="+this.type,
                extFilters: THIS.extFilters,
                browseFileId: "stream_upload_file_btn",
                dragAndDropArea: "stream_upload_file_btn",
                autoUploading: true,
                getExtType:Filetype,
                postVarsPerFile: { /** 上传文件时传入的参数，默认: {} */
                    userID: this.userId,
                },
                onAddTask: function(file) {
                    THIS.type = THIS.getType(file);
                    // THIS._ins.config.uploadURL = config.cmsServer+"upload/newFileStreamUpload.action?type=" + THIS.type;
                    THIS._ins.config.uploadURL = THIS.uploadServer.uploadServerUrl + "/newFileStreamUpload?type=" + THIS.type+"&resize="+THIS.resize;
                    THIS.fileList.push({
                        name: file.name,
                        id: file.id,
                        status: "uploading",
                        showProgress: true,
                        percentage: 0
                    });
                    // setTimeout(() => {
                    //     ins.upload();
                    // }, 100);
                },
                onUploadProgress: function(file) {
                    const _file = THIS.getFile(file);
                    // THIS.onProgress( _file, THIS.fileList);
                    _file.percentage = file.percent || 0;
                    _file.lastPer = _file.lastPer || 0;
                    if(_file.percentage - _file.lastPer > 10) {
                        _file.lastPer = _file.percentage;
                        api.call("material/uploadProgress", {name: _file.name, percent: file.percent});
                    }
                },
                // 处理网络错误和手动取消
                onCancel: function(file) {
                    const _file = THIS.getFile(file);
                    // 如果 THIS.fileList里存在被取消的文件，说明是插件自动移除的，否则是用户点击X或清空列表移除的
                    if (_file) {
                        // 遇到某些错误时，插件会自动移除正在上传的文件
                        // 以及下方的错误处理，也会移除正在上传的文件
                        var msg = THIS.$t('Components.upload.message.uploadError');
                        if(_file.message || errorMsg) {
                            msg += ": " + (_file.message || errorMsg);
                        }
                        THIS.$emit("on-error", _file);
                        THIS.$store.dispatch("uploader/onUploadError", {
                            res: file,
                            file: _file,
                            filelist: THIS.fileList,
                            error: new Error(msg)
                        });
                    }
                },
                onUploadError: function(status, msg) {
                    errorMsg = msg;
                },
                onComplete: function(file) {
                    errorMsg = null;
                    const _file = THIS.getFile(file);

                    if (_file) {
                        file.msg = JSON.parse(file.msg);
                        _file.status = "finished";
                        _file.response = file;

                        THIS.$emit("on-success", file, _file, THIS.fileList);
                        THIS.$store.dispatch("uploader/onUploaded", {
                            res: file,
                            file: _file,
                            image_to_video: THIS.image_to_video,
                            filelist: THIS.fileList,
                            uploadServer: THIS.uploadServer,
                            categoryId: THIS.categoryId,
                            userId: THIS.userId,
                            material: true,
                            vrFlag: THIS.vrFlag
                        });

                        setTimeout(() => {
                            _file.showProgress = false;
                        }, 1000);
                    }
                }
            };

            if(this.maxSize) {
                uploadOptions.maxSize = this.maxSize;
            }

            this._ins = streamUpload(uploadOptions);
            // 处理服务器返回错误
            // 因为 onUploadError 没返回具体文件，这里通过插件内部事件和方法获取
            this._ins.fileProvider.on("uploaderror", event => {
                const fileId = event.target.get("id");
                const _file = THIS.getFile({ id: fileId });

                _file.status = "fail";
                if(event.status == 200) {
                    _file.message = event.source;
                }

                // 不自动取消出错的文件的话，上传会暂停
                THIS._ins.cancelOne(fileId);
            });
        },
        isUploading() {
            let ret;
            this.fileList.every(i => {
                ret = i.status === "uploading";
                return ret;
            });
            return ret;
        },
        getFile(file) {
            const fileList = this.fileList;
            let target;
            fileList.every(item => {
                target = file.id === item.id ? item : null;
                return !target;
            });
            return target;
        },
        clearUploadedList() {
            // 手工取消任务，先从fileList移除，再取消，方便在onCancel中判断是否是用户行为
            let fileListNeedCancel = [];
            this.fileList = this.fileList.filter(i => {
                if(i.status != "uploading")
                    fileListNeedCancel.push(i);
                return i.status == "uploading"
            }); 

            fileListNeedCancel.forEach(i => {
                try {
                    this._ins.cancelOne(i.id);
                } catch (error) {;} // 如果已经调用过cancelOne，在调用会出错
            });
        },
        handleRemove(file) {
            const fileList = this.fileList;
            fileList.splice(fileList.indexOf(file), 1);
            // 手工取消任务，先从fileList移除，再取消，方便在onCancel中判断是否是用户行为
            try {
                this._ins.cancelOne(file.id);
            } catch (error) {;} // 如果已经调用过cancelOne，在调用会出错
        },
        handlePreview(file) {
            if (file.status === "finished") {
                // this.onPreview(file);
                this.$emit("on-preview", file);
            }
        },
        clearFiles() {
            this.fileList = [];
        },
        getType(file) {
            const format =
                (file.name || '')
                    .split(".")
                    .pop()
                    .toLocaleLowerCase() || "";
            let type = 0;

            if (
                ["gif", "jpg", "jpeg", "png", "bmp", "webp"].indexOf(format) >
                -1
            ) {
                console.log(format)
                if(this.image_to_video && format != 'gif'){
                    type = 1;
                }else {
                    type = 2;
                }
            }
            if (
                ["mp4", "flv", "rm", "rmvb", "wmv", "avi", "3gp", "mkv", "mov", "asf", "mpg"].indexOf(format) > -1
            ) {
                type = 1;
            }
            if (
                ["mp3", "aac", "m4a", "amr", "wav", "mp2", "wma", "oga", "weba", "alac", "flac", "asf", "mid", "midi", "vqf", "au", "aifc"].indexOf(format) > -1
            ) {
                type = 7;
            }

            return type;
        },
        sizeText(size) {
            var m = size / 1024 / 1024;
            var g = m / 1024;
            var text = "";
            if(g >= 1) {
                text =  g.toFixed(2).replace(/\.00\b/, '') + "G";
            } else {
                text =  m.toFixed(2).replace(/\.00\b/, '') + "M";
            }
            return text;
        }
    },
    beforeDestroy() {
        this._ins.destroy();
    },
    mounted() {
        this.insInit();
    }
};
</script>
